import _ from 'lodash';

import isDefined from 'isDefined';
import metricTypeCheckers from 'types/metricTypeCheckers';

// Datasets behind a set of metrics. Compound metrics contribute the datasets
// of their input metrics.
const getMetricDataTypes = ({
  metricIds,
  metricOptionsLookup,
}: {
  metricIds: string[];
  metricOptionsLookup: { [metricId: string]: Metrics.Metric | undefined };
}): string[] => {
  const normalMetrics = metricIds
    .map((id) => metricOptionsLookup[id])
    .filter(isDefined)
    .flatMap((m) =>
      metricTypeCheckers.isCompoundMetric(m)
        ? m.metricIds
            .map((id) => metricOptionsLookup[id])
            .filter(isDefined)
            .filter(metricTypeCheckers.isNormalMetric)
        : metricTypeCheckers.isNormalMetric(m)
          ? [m]
          : [],
    );
  return _.uniq(normalMetrics.map((m) => m.dataType)).sort();
};

export default getMetricDataTypes;
